import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import PageHeader from '../../tenant_portal/shared/PageHeader';
import Options from '../Options';
import {
  getCreateAccountEmailPathForPathname,
  getIntentLoginPathForPathname,
} from '../RouteIntents';
import loginStyles from '../../../../stylesheets/components/login.module.scss';

const CreateAccount = () => {
  const location = useLocation();
  const signInPath = getIntentLoginPathForPathname(location.pathname);
  const email = new URLSearchParams(location.search).get('email') || '';
  const emailQueryParams = email !== '' ? { email } : undefined;

  return (
    <div className={loginStyles.loginRouteContent}>
      <PageHeader title="Create an account" includeBottomMargin={false} />
      <p className={loginStyles.loginSubtitle}>
        Already have an account?{' '}
        <Link to={signInPath} className={loginStyles.loginActionLink}>
          Sign in
        </Link>
      </p>
      <Options
        emailPath={getCreateAccountEmailPathForPathname(location.pathname)}
        emailQueryParams={emailQueryParams}
        createAccount
        existingAccountActionTo={signInPath}
      />
    </div>
  );
};

export default CreateAccount;
